export const SHOW_ALERT = "SHOW_ALERT";
export const ALERT_SHOWN = "ALERT_SHOWN";
export const SHOW_MODAL = "SHOW_MODAL";

export const ALERT_TYPES = {
    success: "success",
    error: "error",
    warning: "warning",
    information: "information",
};

export const showAlert = (key, message, type, msgParams, isObj) => {
    return {
        type: SHOW_ALERT,
        alert: {
            key,
            message,
            type,
            msgParams,
            isObj,
        },
    };
};
export const showModal = (key, message, type, msgParams) => {
    return {
        type: SHOW_MODAL,
        alert: {
            key,
            message,
            type,
            msgParams,
        },
    };
};

export const alertShown = (key) => {
    return {
        type: ALERT_SHOWN,
        key,
    };
};
